import axios from "axios"; // Install axios: npm install axios
import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const subjects = [
    "No subject",
    "How to Upload Medical Documents/ I don't see an option to upload documents with form",
    "How soon can I get the second opinion results",
    "How do I book a consultation and what documents are required?",
    "Is it acceptable to seek a second opinion without offending my current treating doctor?",
    "What costs are involved and does SecOpp support insurance or financial assistance?",
    "Can I get nutritional or supportive care advice along with the second opinion?",
    "Are follow-up consultations available after the second opinion?",
    "How secure is my personal and medical data shared on the platform?",
    "Partnership or Collaboration Inquiry",
    "Other",
];

function ContactForms() {
    const location = useLocation();
    const navigate = useNavigate();
    const isSubmitted = location.pathname.includes("thank-you");

    const initialFormState = {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        subject: subjects[0],
        helpyou: "",
    };

    const [formData, setFormData] = useState(initialFormState);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { id, value } = e.target;
        
        // Phone field - only allow numbers and max 10 digits
        if (id === "phone") {
            const numericValue = value.replace(/\D/g, ""); // Removes all non-numeric characters
            const limitedValue = numericValue.slice(0, 10); // Limits to 10 digits
            setFormData((prevFormData) => ({
                ...prevFormData,
                [id]: limitedValue,
            }));
        } else {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [id]: value,
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isSubmitting) return;

        // Validate phone number is exactly 10 digits
        if (formData?.phone?.length !== 10) {
            alert("Phone number must be exactly 10 digits.");
            return;
        }

        setIsSubmitting(true);
        try {
            const timestamp = new Date().toLocaleString();
            const params = new URLSearchParams(window.location.search);
            params.append("FirstName", formData.firstName);
            params.append("LastName", formData.lastName);
            params.append("Email", formData.email);
            params.append("Phone", formData.phone);
            params.append("Subject", formData?.subject || "");
            params.append("Helpyou", formData?.helpyou || "");
            params.append("Timestamp", timestamp);

            await axios.post(process.env.REACT_APP_CONTACT_API_URL, params);

            setFormData(initialFormState);
            navigate("/contact/thank-you");
        } catch (error) {
            console.error("Form submission error:", error);
            alert("Something went wrong. Please try again later.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="bg-light d-flex align-items-center justify-content-center min-vh-75 tw-p-6 md:tw-p-12 tw-flex-1 md:tw-w-1/2">
            <div
                className={`bg-white ${isSubmitted ? "tw-p-10" : "tw-p-6 md:!tw-p-12"} rounded shadow-lg w-100`}
                style={{ maxWidth: "600px" }}
            >
                <h1 className="tw-text-dark-blue tw-text-center tw-text-2xl tw-mb-6">
                {isSubmitted ? "Thank You" : "Contact Us"}
                </h1>
                {isSubmitted ? (
                    <div className="text-center">
                        <p className="text-muted">We will get back to you shortly. In the meantime, if you have any doubts please Call / WhatsApp on <a href="https://wa.me/919510104052" target="_blank" rel="noopener noreferrer">+91 95101 04052</a>.</p>
                        <Link to="/">
                            <button className="btn tw-text-white tw-bg-[#00213e] hover:tw-text-white hover:tw-bg-[#00213e]">
                                Go Back
                            </button>
                        </Link>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label" htmlFor="firstName">
                                Name <span className="text-danger">*</span>
                            </label>
                            <div className="d-flex">
                                <input
                                    className="form-control me-2 tw-placeholder-gray-400"
                                    id="firstName"
                                    type="text"
                                    placeholder="First"
                                    required
                                    value={formData.firstName}
                                    onChange={handleChange}
                                />
                                <input
                                    className="form-control tw-placeholder-gray-400"
                                    id="lastName"
                                    type="text"
                                    placeholder="Last"
                                    required
                                    value={formData.lastName}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="form-label" htmlFor="email">
                                Email <span className="text-danger">*</span>
                            </label>
                            <input
                                className="form-control"
                                id="email"
                                type="email"
                                required
                                value={formData.email}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label" htmlFor="phone">
                                Phone Number{" "}
                                <span className="text-danger">*</span>
                            </label>
                            <input
                                className="form-control"
                                id="phone"
                                type="tel"
                                required
                                value={formData.phone}
                                onChange={handleChange}
                                maxLength={10}
                                pattern="[0-9]{10}"
                                title="Phone number must be exactly 10 digits... "
                            />
                        </div>

                        {/* <div className="mb-3">
                            <label className="form-label" htmlFor="subject">
                                Subject
                            </label>
                            <select
                                className="form-select"
                                id="subject"
                                aria-label="Default select example"
                                value={formData.subject}
                                onChange={handleChange}
                            >
                                {subjects.map((subject, index) => (
                                    <option
                                        className="tw-text-sm"
                                        key={index}
                                        value={subject}
                                    >
                                        {subject}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="mb-3">
                            <label className="form-label" htmlFor="helpyou">
                                How can we help you?
                            </label>
                            <textarea
                                className="form-control"
                                id="helpyou"
                                rows="4"
                                value={formData.helpyou}
                                onChange={handleChange}
                            ></textarea>
                        </div> */}

                        <div className="d-flex justify-content-center">
                            <button
                                className="btn"
                                type="submit"
                                style={{
                                    backgroundColor: "#00213e",
                                    color: "white",
                                    border: "none",
                                }}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? "Submitting..." : "Submit"}
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}

export default ContactForms;
